// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d_UY0","type":"styles_type__vzznz","choices":"styles_choices__38j0e"};